import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot, RouterStateSnapshot,
    CanActivate, Router
} from "@angular/router";
import { Observable } from "rxjs";
import { ConfigService } from "./config.services";
import { LocalService } from "./local.service";
import { NativeService } from "./native.service";

@Injectable({
    providedIn: 'root'
})
export class AuthService implements CanActivate {

  private readonly apiUrl = `${this.config.getUrlRofer()}/Auth`;
  
    constructor(
        private nativeService: NativeService,
        private localService: LocalService,
        private router: Router,
        private config: ConfigService,
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (this.localService.isLoggedIn !== true) {
            this.nativeService.OnlyAlert('Notificación', 'No tiene acceso, por favor inicie sesión', '').then(()=>{
                this.router.navigate(['']);
            })
        }
        return true;
    }

    login(loginRequest: any): any {
        const url = `${this.apiUrl}/Login`;
        return this.config.Post(url, loginRequest);
    }

    // Epicor
    postLogin(usuario) : any {
        return this.config.Post(`${this.config.getUrlIdentity()}/authenticate`,usuario)
    }
}
